import React from 'react';
/**
 * TabContext
 * {
 *  activeTabId: PropTypes.any
 * }
 */

export var TabContext = /*#__PURE__*/React.createContext({});


//////////////////
// WEBPACK FOOTER
// ../~/reactstrap/es/TabContext.js
// module id = 473
// module chunks = 0